import * as Preact from "preact"

import App from "@fae/source/models/App.js"

import * as PlotSteps from "@fae/source/data/plot/steps.js"

import "./CookingModal.less"
let UnitSprite = function() {}
import("@fae/source/views/components/UnitSprite.jsx").then((module) => UnitSprite = module.default)
import UnitHealthBar from "@fae/source/views/components/UnitHealthBar.jsx"

function onClickFeedAllButton() {
    const foods = getFoods()
    const foodneeds = calculateTotalFoodNeeds()

    if(foods.length < foodneeds) {
        console.log("NOPE, NOT ENOUGH FOOD")
        return
    }
    for(let i = 0; i < foodneeds; i += 1) {
        const food = foods[i]
        delete App.game.player.inventory.items[food.key]
    }

    Object.values(App.game.player.units).forEach((unit) => {
        unit.health = unit.maxhealth
        unit.isFed = true
    })

    console.log("EVERYONE IS FULLY FED!!")
}

function onClickFeedButton(unitKey) {
    const foods = getFoods()
    const foodneeds = 1

    if(foods.length < foodneeds) {
        console.log("NOPE, NOT ENOUGH FOOD")
        return
    }
    for(let i = 0; i < foodneeds; i += 1) {
        const food = foods[i]
        delete App.game.player.inventory.items[food.key]
    }

    const unit = App.game.player.units[unitKey]
    unit.health = unit.maxhealth
    unit.isFed = true

    console.log("LONG REST!!")
}

function getUnits() {
    if(App?.game?.player?.units == undefined) return []
    return Object.values(App.game.player.units).filter((unit) => unit.isDead != true && unit.isRecruited == true)
}

function getHungryUnits() {
    return getUnits().filter((unit) => unit.isFed != true)
}

function getFoods() {
    if(App?.game?.player?.inventory?.items == undefined) return []
    return Object.values(App.game.player.inventory.items).filter((item) => item.type == "food")
}

function getFoodCount() {
    return getFoods().length
}

function calculateTotalFoodNeeds() {
    const allies = getHungryUnits()
    return Math.max(0, Math.min(allies.length, 4))
}

export default function CookingModal() {
    return PlotSteps.GameplayModal({
        "view": () => {
            if(App?.game == undefined) return
            return (
                <div class="CookingModal">
                    <section class="FeedSection">
                        <button onClick={onClickFeedAllButton} isEnabled={getFoodCount() >= calculateTotalFoodNeeds()}>
                            Feed All! {calculateTotalFoodNeeds() * 10} Food
                        </button>
                    </section>
                    <section class="UnitsSection">
                        {getUnits().map((unit) => {
                            return (
                                <div class="Unit">
                                    <div class="Sprite">
                                        <UnitSprite unit={unit}/>
                                        <UnitHealthBar unit={unit} maxsegments={20}/>
                                    </div>
                                    <div class="Description">
                                        <div class="Name">{unit.name}</div>
                                        {unit.isFed == true ? <div class="Status">Fed</div> : <div class="Status" color="red">Hungry</div>}
                                        <button class="FeedButton" onClick={() => onClickFeedButton(unit.key)} isEnabled={getFoodCount() >= 1}>
                                            Feed {1 * 10} Food
                                        </button>
                                    </div>
                                </div>
                            )
                        })}
                    </section>
                    <section class="FoodsSection">
                        current foods: {getFoods().length * 10}
                    </section>
                    <section class="DoneSection">
                        <button onClick={() => App.sequence.steps.shift()}>Done</button>
                    </section>
                </div>
            )
        }
    })
}
